var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 195",
    style: {
      enableBackground: "new 0 0 600 195"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#005A2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.2,36.9c-10.3-5.7-22.3-8.7-35.6-8.7c-13.5,0-25.6,2.9-35.9,8.7c-10.3,5.8-18.4,13.8-24,23.9 c-5.6,10-8.4,21.6-8.4,34.2c0,12.7,2.8,24.2,8.4,34.2c5.6,10.1,13.7,18.1,24,23.9c10.3,5.7,22.4,8.7,35.9,8.7 c13.3,0,25.3-2.9,35.6-8.7c10.3-5.8,18.4-13.8,24-23.9c5.6-10,8.4-21.6,8.4-34.2c0-12.7-2.8-24.2-8.4-34.2 C276.6,50.7,268.5,42.6,258.2,36.9z M241.6,127.3c-5.5,3.3-11.9,5-19,5c-7.2,0-13.6-1.7-19-5c-5.5-3.3-9.8-7.9-12.8-13.5 c-3-5.6-4.6-12-4.6-18.9c0-6.9,1.5-13.2,4.6-18.9c3-5.6,7.3-10.2,12.8-13.5c5.5-3.3,11.9-5,19-5s13.6,1.7,19,5 c5.5,3.3,9.7,7.9,12.6,13.5c2.9,5.7,4.4,12,4.4,18.9c0,6.9-1.5,13.2-4.4,18.9C251.3,119.4,247,124,241.6,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.2,129.5c-5.1,2.4-10,3.6-14.8,3.6c-5.2,0-9-1.4-11.5-4.4c-2.6-3-3.8-7.5-3.8-13.3V59.9h35.6V32h-35.6V4 h-31.8v28h-6.5c-10.5,0-19.1,8.5-19.1,19.1v8.9h25.5l0,55.4c0,15,3.7,26.6,11.1,34.5c7.4,7.9,18,11.9,31.6,11.9 c5.3,0,10.2-0.5,14.6-1.4c4.4-0.9,9.1-2.3,14.1-4.6l1.1-0.5l-8.9-26.7L384.2,129.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.1,
    y: 32,
    className: "st0",
    width: 31.8,
    height: 127.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "550.5,93.6 593.3,32 556,32 537.9,58.6 530,71 522.3,58.5 504.2,32 466.4,32 509.2,93.6 463.7,159.2 500.7,159.2 518,134.3 530,116.2 541.6,134.3 558.2,159.2 596,159.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67,28.2h-1.1C31.8,28.2,4,56,4,90.1v71.6h1.9c17.6,0,29.9-13.9,29.9-33.9V90.1c0-14.6,12.1-30.2,30.2-30.2 H67c17.7,0,30,15.9,30,30.2v37.7c0,20,12.4,33.9,30,33.9h1.9V90.1C128.9,56,101.2,28.2,67,28.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.5,170.7c-7.5,0-14.9-0.4-22.2-1.1c0.4,11.9,10.2,21.4,22.2,21.4c12,0,21.8-9.5,22.2-21.4 C81.4,170.3,74,170.7,66.5,170.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLogo);
export default __webpack_public_path__ + "static/media/desktop_logo.b64a598355bd1119c60f1e4b47168344.svg";
export { ForwardRef as ReactComponent };